import { render, staticRenderFns } from "./AtomRadio.vue?vue&type=template&id=31be9f00&scoped=true&"
import script from "./AtomRadio.vue?vue&type=script&lang=ts&"
export * from "./AtomRadio.vue?vue&type=script&lang=ts&"
import style0 from "./AtomRadio.vue?vue&type=style&index=0&id=31be9f00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31be9f00",
  null
  
)

export default component.exports